<template>
    <div class="payment-page">
        <div class="payment-page__header">
            <img src="@images/portal/kwiga_logo.svg" alt="KWIGA" />
        </div>
        <div class="payment-page__wrapper">
            <PaymentModal
                v-if="true"
                :title="title"
                :text="text"
                :partialPayment="partialPayment"
                :oldPrice="oldPrice"
                :price="price"
                :isBonusPayment="isBonusPayment"
                :currency="currency"
                @toggle-tooltip="$refs.TooltipModal.showTooltip()"
            />
            <Tooltip
                ref="TooltipModal"
                :dataTooltip="dataTooltip"
                class="payment-page__tooltip"
                additionalListClass="payment-page__tooltip__list"
            />
        </div>
        <!-- <button class="btn btn_default" style="width: 100%" data-modal-show="modal-login">
    Авторизоваться
  </button> -->
        <!-- <div class="modal-subscribe modal-subscribe_visible" id="auth" data-modal="modal-login">
      <div class="modal-subscribe-bg js-close"></div>
      <modal-auth></modal-auth>
  </div> -->
    </div>
</template>

<script>
import PaymentModal from "@components/PaymentsModals/PaymentModal"
import Tooltip from "@components/Tooltips/Tooltip"

export default {
    name: "PaymentPage",
    components: { PaymentModal, Tooltip },
    props: ["title", "text", "price", "currency", "oldPrice", "partialPayment", "isBonusPayment"],
    data() {
        return {
            dataTooltip: {
                title: "Описание частичной оплаты",
                text: "Тут выводится описание частичной оплаты, та которая вводится под суммой в шагах.Тут выводится описание частичной оплаты, та которая вводится под суммой в шагах.Описание",
                subtitle: "Сумма след. платежа",
                list: ["600 UAH"]
            }
        }
    }
}
</script>
